import React from "react";
import {observer} from "mobx-react";
import {FormProps} from "../../form/formUtils";
import {ParamTable} from "../domain/tenantDomain";
import Form, {DefinitionType, FIELDDEFDISPLAYTYPE} from "../../form/form";
import {createForm} from "../../form/createForm";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../form/closedForm";
import {BlockComp} from "../../components/blockComp/blockComp";
import StyledSelect from "../../components/fields/styledSelect";
import {MdTextField} from "../../components/fields/fields";
import {IsRequired} from "../../form/rules";
import {Validate} from "../../form/validate";
import tenantService from "../service/tenantService";
import {action, reaction} from "mobx";
import MdField, {VALUESOURCETYPE} from "../../metamodel/mdField";

@observer
class ParamTableForm extends React.Component<FormProps<ParamTable, ParamTable>, undefined> {


  constructor(props: FormProps<ParamTable, ParamTable>, context: any) {
    super(props, context);

    reaction(
      () => tenantService.paramTableObject.paramKey,
      paramKey => {
        let {dataObject, form} = this.props;
        this.isValueAssignableToParamKey(dataObject, form);
      }
    );

    reaction(
      () => tenantService.paramTableObject.value,
      value => {
        let {dataObject, form} = this.props;
        this.isValueAssignableToParamKey(dataObject, form);
      }
    );
  }

  @action onTenantChange = ({lovItem, changedField, touchField}) => {
    let {dataObject, form} = this.props;

    form.getField(changedField).props.onChange(lovItem);

    dataObject[touchField] = null;
    form.updateFieldsPropValue(dataObject, touchField)
  };

  isValueAssignableToParamKey = (dataObject: ParamTable, form: Form<ParamTable>) => {
    let {paramKey, value} = dataObject;

    if (!paramKey || !value)
      return;

    let valueField = form.getField("value");

    tenantService.checkIfValueIsAssignableToParamKey(paramKey, value)
      .then(() => {
        valueField.valid = true;
        valueField.showValidation = false;
        valueField.props.errorText = null;
        valueField.errorText = null;
      })
      .catch(err => {
        const messArray = err.getMessages();
        const mess = messArray? messArray[0].message : "Error";

        valueField.valid = false;
        valueField.showValidation = true
        valueField.props.errorText = mess;
        valueField.errorText = mess;
      });

  }

  render() {

    let {dataObject, rootObject, entities, entity, form} = this.props;
    let fields = dataObject.getFormFields(ParamTableFormDefinition.formName);
    let {paramKey, value, tenantGroup, tenant} = fields;

    const openContent: JSX.Element = (
      <form style={{marginTop: 10}}>
        <BlockComp>
          <div className="row">
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...paramKey.props} disabled={!dataObject.$new}/>
              <Validate field={paramKey} value={paramKey.props.value}>
                <IsRequired/>
              </Validate>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenantGroup.props} onChange={(v) => this.onTenantChange({
                lovItem: v,
                changedField: "tenantGroup",
                touchField: "tenant"
              })} disabled={!dataObject.$new}/>
              <Validate field={tenantGroup} value={tenantGroup.props.value}/>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenant.props} onChange={(v) => this.onTenantChange({
                lovItem: v,
                changedField: "tenant",
                touchField: "tenantGroup"
              })} disabled={!dataObject.$new}/>
              <Validate field={tenant} value={tenant.props.value}/>
            </div>
          </div>
          <div className="row">
            <div className="fx col-xs-12 zz-mb-5">
              <MdTextField {...value.props} multiLine={true} maxLength={4096} />
              <Validate field={value} value={value.props.value}>
                <IsRequired/>
              </Validate>
            </div>
          </div>
        </BlockComp>
      </form>
    );

    return openContent;
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ParamTable>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.paramKey.textLabel} value={dataObject.paramKey}/>
    </ClosedFormBlock>
  </div>
);


export const ParamTableFormDefinition: DefinitionType = {
  formName: 'ParamTableForm',
  fields: [{
    name: 'paramKey',
    validators: ['IsRequired']
  }, {
    name: 'value',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'tenantGroup',
    mdField: new MdField({label: "Tenant Group", valueSourceType: VALUESOURCETYPE.ASYNC})
  }, {
    name: 'tenant',
    mdField: new MdField({label: "Tenant", valueSourceType: VALUESOURCETYPE.ASYNC})
  },]
};

export default createForm(ParamTableFormDefinition, ClosedContent)(ParamTableForm);



// WEBPACK FOOTER //
// ./src/core/tenant/paramkey/paramTableForm.tsx